<template>
  <div>
    <div class="container free-wrapper">
        <div class="featured">
          <p>Become a</p>
          <span class="founding-member">FOUNDING MEMBER</span>
          <del>($599)</del>
          <h5>Membership Includes:</h5>
          <div class="per-year">
            <h3>&dollar;300</h3>
            <p>per year</p>
          </div>
          <ul>
            <li>Set Expiration Alerts</li>
            <li>Identify Predicates</li>
            <li>Research Classifications</li>
            <li>Access to exclusive ROSE  
                data and tools</li>
          </ul>
          <p>Available for a limited time.</p>
          <router-link v-if='!user' to="/login" class="orange-btn kkk" style="color: #333; background: #fff;">
            <a>Buy Now</a>
          </router-link>
          <router-link v-else to="/billing-info" class="orange-btn" style="color: #333; background: #fff;">
            <a>Buy Now</a>
          </router-link>
        </div>
        <div class="markets">
          <h4>Includes Access to All Markets:</h4>
          <div class="market-items">
            <div class="market-item">
              <h6>Southeast Asia</h6>
              <li>Singapore</li>
              <li>Thailand</li>
              <li>Indonesia</li>
              <li>Philippines</li>
              <li>Malaysia</li>
              <li>Vietnam <br class="coming-br"/> (coming soon 2021)</li>
            </div>
            <div class="market-item">
              <h6>South Asia <br class="coming-br"/> (coming soon 2021)</h6>
              <li>India</li>
              <li>Bangladesh</li>
            </div>
            <div class="market-item">
              <h6>Greater China <br class="coming-br"/> (coming soon 2021)</h6>
              <li>China</li>
              <li>Hong Kong</li>
              <li>Taiwan</li>
            </div>
            <div class="market-item">
              <h6>Asia Pacific <br class="coming-br"/> (coming soon 2021)</h6>
              <li>Australia</li>
              <li>New Zealand</li>
            </div>
            <div class="market-item">
              <h6>N. America <br class="coming-br"/> (coming soon 2021)</h6>
              <li>United States</li>
              <li>Canada</li>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import * as isUserLoggedIn from '@/store/isUserLoggedIn';

export default {
  data() {
			return {
					user: isUserLoggedIn.isUserLoggedIn()
			}
	},
}
</script>

<style lang="scss">
  .free-wrapper {
      background: #fff;
      box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
      border-radius: 15px;
      display: flex;

      .featured {
        padding: 35px 0 50px 0;
        background: linear-gradient(337.88deg, #FC7C05 0%, #FCAF05 100%);
        border-radius: 15px;
        color: #fff;
        max-width: 320px;

        p,
        span,
        h5,
        ul,
        del,
        .per-year {
          padding: 0 50px;
        }

        a {
          margin: 0 50px;
        }

        p {
          margin-bottom: 4px;

          &:last-of-type {
            font-size: 14px;
            margin-top: 25px;
          }
        }

        span.founding-member {
          display: block;
          background: linear-gradient(337.88deg, rgba(252, 124, 5, 0.2) 0%, rgba(252, 124, 5, 0.2) 100%);
          font-family: "Gotham-Bold";
          padding: 6px 50px;
        }

        del {
          display: block;
          margin-top: 25px;
          font-family: "Gotham-Book";
        }

        .per-year {
          display: flex;
          align-items: flex-end;

          h3 {
            font-size: 42px;
            line-height: 67px;
            margin: 0;
          }

          p {
            padding: 0;
            margin: 0 0 10px 6px;
          }
        }

        ul {
          padding-inline-start: 70px;

          li {
            margin-bottom: 11px;

            &:last-of-type {
              margin-bottom: 0;
            }
          }
        }
      }

      .markets {
        padding: 35px 0 35px 65px;
        background: url('~@/assets/images/components/fee-home.svg') bottom right no-repeat;

        h4 {
          font-size: 18px;
          line-height: 29px;
          margin-bottom: 50px;
        }

        .market-items {
          display: flex;
          flex-wrap: wrap;

          .market-item {
            margin-right: 8%;
            margin-bottom: 55px;

            h6 {
              margin-bottom: 23px;
            }

            .coming-br {
              display: none;
            }
          }
        }
      }
    }
</style>